module.exports = function() {
  return new Worker(__webpack_public_path__ + "e5af5087fd6591533fa1.worker.js");
};